// extracted by mini-css-extract-plugin
export default {"buttonLoginContainer":"ButtonLogin_buttonLoginContainer__tkuLP","button":"ButtonLogin_button__l-veb"};